import VerticallyCenteredModal from "../CenteredModal/CenteredModal";
import DataPreviewTable from "./DataPreviewTable";

function DataPreviewModal({show, onHide, tableName, tableColumns, tableData}){

    return (
        <VerticallyCenteredModal 
            title={`${tableName} data preview`} 
            content={<DataPreviewTable tableColumns={tableColumns} tableData={tableData} />}
            show={show}
            onHide={onHide}
        />
    )
}

export default DataPreviewModal;